export enum ENABLED_CATEGORIES {
  OTHER = 'pozostale',
  SERVICES = 'obsluga',
  INTERSHIP = 'praktyki-i-staze',
  ALL_OFFERS = 'wszystkie-oferty',
  SELL = 'sprzedaz',
  TECHNOLOGIES = 'technologie'
}
